/**
 * Oferta w karcie klienta (decyzja właściciela 2026-10-11): jedna oferta na klienta, `dane.oferta`
 * = { numer, data, wazneDo, wersja }. Treść dokumentu nie jest zapisywana: składa się przy każdym podglądzie
 * z karty (zestaw, cena dla klienta, Projekt 3D, adres), więc ten sam PDF „uzupełnia się sam”.
 *
 * Numer OF/RRRR/MM/NNNN, gdzie NNNN to numer karty klienta: niepowtarzalny w firmie i stały dla klienta.
 * Ważność domyślnie 14 dni od przygotowania. Nowa wersja (zmiana zestawu albo ceny) dostaje nową datę
 * i ważność, a numer zostaje.
 */

export const WAZNOSC_DNI = 14

const iso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
const plusDni = (dzienIso, dni) => {
  const [r, m, d] = dzienIso.split('-').map(Number)
  return iso(new Date(r, m - 1, d + dni))
}

export const numerOferty = (klientId, dzienIso) => {
  const [r, m] = dzienIso.split('-')
  return `OF/${r}/${m}/${String(klientId ?? 0).padStart(4, '0')}`
}

export const ofertaZDanych = (dane) => {
  const o = dane?.oferta
  return o && o.numer ? { numer: o.numer, data: o.data || '', wazneDo: o.wazneDo || '', wersja: o.wersja || 1 } : null
}

export const nowaOferta = (klientId, dzien = new Date()) => {
  const data = iso(dzien)
  return { numer: numerOferty(klientId, data), data, wazneDo: plusDni(data, WAZNOSC_DNI), wersja: 1 }
}

export const nowaWersja = (oferta, dzien = new Date()) => {
  const data = iso(dzien)
  return { ...oferta, data, wazneDo: plusDni(data, WAZNOSC_DNI), wersja: (oferta.wersja || 1) + 1 }
}

/** „11.10.2026” z „2026-10-11”. */
export const dataPl = (dzienIso) => {
  const [r, m, d] = String(dzienIso || '').split('-')
  return r && m && d ? `${d}.${m}.${r}` : ''
}

/** Czy oferta jest jeszcze ważna w danym dniu. */
export const wazna = (oferta, dzien = new Date()) => Boolean(oferta?.wazneDo) && oferta.wazneDo >= iso(dzien)
